module.exports = __webpack_public_path__ + "img/ic_pic_hanging.4ea82060.svg";